var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.775 12.0337C13.848 11.0602 12.723 10.2833 11.471 9.75182C10.2189 9.22047 8.86684 8.94616 7.50001 8.94616C6.13317 8.94616 4.78114 9.22047 3.52907 9.75182C2.277 10.2833 1.15203 11.0602 0.224996 12.0337C0.0818744 12.1871 0.00180365 12.3861 0 12.5929V15.9481C0.00302794 16.1686 0.0955385 16.379 0.257506 16.5339C0.419462 16.6888 0.637857 16.7757 0.865378 16.7757H14.1346C14.3641 16.7757 14.5843 16.6873 14.7465 16.53C14.9088 16.3726 15 16.1593 15 15.9368V12.5817C14.9954 12.3788 14.9155 12.1842 14.775 12.0337Z",
    fill: "#101728"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50014 7.82863C9.73055 7.82863 11.5386 6.07613 11.5386 3.91432C11.5386 1.7525 9.73055 0 7.50014 0C5.26975 0 3.46167 1.7525 3.46167 3.91432C3.46167 6.07613 5.26975 7.82863 7.50014 7.82863Z",
    fill: "#101728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.13f4b7a2d20e60a7e0c8a3ebdc5c2db2.svg";
export { ForwardRef as ReactComponent };